export const LIGHT_BLACK = "#616161";
export const LIGHT_GREY = "#F5F5F5";
export const SYSTEM_BLUE = "#127FFF";
export const PRIMARY = "#2813AD";
